export const seo = {
  seo: {
    jakooTitle: 'online kaufen » JAKO-O',
    jakooPrefixDescription: 'Hochwertiges & ausgewähltes',
    jakooSuffixDescription:
      '✓ Für Familien gemacht. ✓ Von Familien getestet. ➽ Hier bei JAKO-O bestellen!',
    jakooProductDescription:
      '- bei JAKO-O ✓ nachhaltige Qualität ✓ durchdachte Funktion ✓ ausgewählte Produkte: Jetzt bestellen!',
    habaTitle: 'online kaufen » HABA',
    habaPrefixDescription: 'Hochwertiges & ausgewähltes',
    habaSuffixDescription:
      '✓ Für Familien gemacht. ✓ Von Familien getestet: Hier bei HABA bestellen!',
    habaProductDescription:
      '- bei HABA ✓ nachhaltige Qualität ✓ durchdachte Funktion ✓ : Jetzt bestellen!',
  },
};
